import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/booking/details/BookingClient.tsx");
